<template>
  <modal
    class="ce-userValidation"
    @close="close"
    :headline="$t('userProfile.requestValidationModal.headline')">
    <div class="ce-modalContent">
      <div>
        <p class="mt0 mb3">
          {{ $t('userProfile.requestValidationModal.content') }}
        </p>
      </div>

      <ValidationObserver
        ref="validationObserver"
        tag="div">
        <ValidationProvider
          :name="$t('userValidation.region.label')"
          v-slot="{ errors }"
          rules="required"
          mode="eager"
          tag="div"
          class="ce-field">
          <label>
            {{ $t('userValidation.region.label') }} <span>*</span>
            <span
              v-if="errors.length > 0"
              class="ms-2 ml1 regular ce-colorError">
              {{ errors[0] }}
            </span>
          </label>
          <select
            v-model="form.region">
            <option
              v-for="region in contactRegions"
              :key="region.code"
              :value="region.code">
              {{ region.title }}
            </option>
          </select>
        </ValidationProvider>

        <ValidationProvider
          v-if="selectedRegion && selectedRegion.subRegions"
          :name="$t('userValidation.subRegion.label')"
          v-slot="{ errors }"
          rules="required"
          mode="eager"
          tag="div"
          class="ce-field">
          <label>
            {{ $t('userValidation.subRegion.label') }} <span>*</span>
            <span
              v-if="errors.length > 0"
              class="ms-2 ml1 regular ce-colorError">
              {{ errors[0] }}
            </span>
          </label>
          <select
            v-model="form.subRegion">
            <option
              v-for="subRegion in selectedRegion.subRegions"
              :key="subRegion.code"
              :value="subRegion.code">
              {{ subRegion.title }}
            </option>
          </select>
        </ValidationProvider>

        <div>
          <button
            class="ce-btn ce-btn-light"
            @click.prevent="submit">
            <template v-if="loading">
              <fa-icon
                icon="spinner"
                spin />
            </template>
            <template v-else>
              {{ $t('userValidation.submitCta') }}
            </template>
          </button>

          <button
            class="ce-btn ce-btn-grey"
            @click.prevent="close">
            {{ $t('userValidation.cancelCta') }}
          </button>
        </div>
      </ValidationObserver>
    </div>
  </modal>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      form: {
        region: 'europe',
        subRegion: null
      },
      loading: false
    };
  },
  computed: {
    ...mapState('generic', ['contactRegions']),
    ...mapGetters('user', ['tokenPayload']),
    selectedRegion() {
      if (this.form.region) {
        return this.contactRegions.find((r) => r.code === this.form.region);
      }

      return null;
    },
    selectedSubRegion() {
      if (this.selectedRegion
        && this.selectedRegion.subRegions
        && this.form.subRegion) {
        return this.selectedRegion.subRegions.find((sR) => sR.code === this.form.subRegion);
      }

      return null;
    }
  },
  methods: {
    ...mapActions('user', ['requestValidation']),
    close() {
      this.$emit('close');
    },
    async submit() {
      this.loading = true;
      const result = await this.$refs.validationObserver.validate();

      if (result) {
        await this.requestValidation({
          region: this.selectedRegion,
          subRegion: this.selectedSubRegion
        });
        this.close();

        this.loading = false;
      } else {
        this.loading = false;
      }
    }
  }
};
</script>
